export const DEFAULT_BUSINESS_METRICS_OPTIONS = {
    tablet: {
        columns: 2,
        'row-gap': '24px',
        'column-gap': '32px',
    },
    desktopWide: {
        columns: 4,
        'row-gap': '24px',
        'column-gap': '40px',
    },
};
